module.exports = __webpack_public_path__ + "static/media/sign-up-banner.625a1df5.png";